import { OverlayProps, Overlay } from '@mantine/core';
import { zIndexes } from '@styles/zindex/zindex';
import styled, { createGlobalStyle } from 'styled-components';
import React, { forwardRef } from 'react';
import { Container } from '@layout/navigation/navigation.styles';

const DisableScroll = createGlobalStyle`
  /* Disable scroll on app container */
  ${Container} {
    overflow: hidden;
  }
`;
type GlobalOverlayProps = OverlayProps &
  React.RefAttributes<HTMLDivElement> &
  React.HTMLAttributes<HTMLDivElement>;
type GlobalOverlayType = React.ForwardRefExoticComponent<GlobalOverlayProps>;

function GlobalOverlay(
  props: GlobalOverlayProps,
  ref: React.Ref<HTMLDivElement>,
) {
  return (
    <>
      <DisableScroll />
      <Overlay
        opacity={0}
        zIndex={zIndexes.indexOf('page-overlay')}
        {...props}
        ref={ref}
      />
    </>
  );
}

const StyledGlobalOverlay = styled(forwardRef(GlobalOverlay))`
  &.mantine-Overlay-root {
    position: fixed;
    cursor: auto;
  }
`;

export default React.memo(StyledGlobalOverlay) as GlobalOverlayType;
